const useColorMap = (colorMap, setColorMap) => {
  const getColor = (primerId) => {
    for (const key in colorMap) {
      if (colorMap[key] === primerId) {
        return key;
      }
    }
  };

  const addPrimer = (primerId) => {
    setColorMap((colorMap) => {
      const copy = { ...colorMap };
      for (const color in copy) {
        if (copy[color] === undefined) {
          copy[color] = primerId;
          break;
        }
      }
      return copy;
    });
  };

  const removePrimer = (primerId) => {
    setColorMap((colorMap) => {
      return {
        ...colorMap,
        [getColor(primerId)]: undefined,
      };
    });
  };

  // mainly for instantiating real primer from temporary id
  const replacePrimer = (oldId, newId) => {
    setColorMap((colorMap) => {
      return {
        ...colorMap,
        [getColor(oldId)]: newId,
      };
    });
  };

  return {
    getColor,
    addPrimer,
    removePrimer,
    replacePrimer,
  };
};

export default useColorMap;
